import loadable from '@loadable/component';
import React from 'react';

/* istanbul ignore next */
export default loadable(
    () =>
        import(
            /* webpackChunkName: "MPRestrictedPaymentMessageLazy" */ './MPRestrictedPaymentMessage'
        ),
    {
        fallback: <div />,
    }
);
